"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_class_component_1 = require("vue-class-component");
function getDeepValue(st, obj) {
    return st.replace(/\[([^\]]+)]/g, '.$1').split('.').reduce(function (o, p) {
        return o[p];
    }, obj);
}
function State2Way(mutation, stateVariable) {
    return vue_class_component_1.createDecorator((componentOptions, k) => {
        if (!componentOptions.computed) {
            componentOptions.computed = {};
        }
        componentOptions.computed[k] = {
            get() {
                if (typeof stateVariable === "string") {
                    return stateVariable ? getDeepValue(stateVariable, this.$store.state) : this.$store.state[k];
                }
                else if (stateVariable) {
                    return stateVariable(this.$store.state);
                }
            },
            set(val) {
                this.$store.commit(mutation, val);
            }
        };
    });
}
exports.State2Way = State2Way;
